import React, { useEffect } from 'react'
import { IApplicationState } from 'Store/types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import GetCustomerInfoPage from './GetCustomerInfoPage'
import GetCarInfoPage from './GetCarInfoPage'
import VehicleVisitingPointsMode1Page from './VehicleVisitingPointsMode1Page'
import VehicleVisitingPointsMode2Page from './VehicleVisitingPointsMode2Page'
import GetPricePage from './GetPricePage'
import ImagesCheck from './ImagesCheck'
import VehicleAccessoriesPage from './VehicleAccessoriesPage'
import GetDescriptionPage from './GetDescriptionPage'
import NotHealthyAutoPartsPage from './NotHealthyAutoPartsPage'
import GetDeliberatelyPage from './GetDeliberatelyPage'
import AccessDenied from './AccessDenied'
import GetOptionsPage from './GetOptionsPage'
import { useSettings } from 'Contexts/SettingsContext'
import NewVisitHeader from './NewVisitHeader'
import Const from 'Utils/Consts'
import { useGetInsuranceExpertFieldsCurrentUserQuery, useGetUserProfileQuery } from 'Services/api'

const NewVisitPage = () => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const takePictureMode =
    settings?.REACT_APP_TAKE_PICTURES_MODE != undefined
      ? settings?.REACT_APP_TAKE_PICTURES_MODE
      : Const.env.REACT_APP_TAKE_PICTURES_MODE
  const [activeStep, setActiveStep] = React.useState(0)

  const { data: userProfileData } = useGetUserProfileQuery()
  const { data: expertData } = useGetInsuranceExpertFieldsCurrentUserQuery()

  // useEffect(() => {
  //   if (activeStep == 6) {
  //     if (carInfo.vehicleStatus == 1)
  //       setActiveStep(7)
  //   }
  // }, [activeStep])

  const hasAccess = (): number => {
    // if (expertData.getInsuranceExpertFieldsLoaded) {
    //   if (expertData) {
    //     var insurance = expertData.getInsuranceExpertFieldsData.find((x: any) => x.insuranceTypeCoreId == 44)
    //     if (insurance) {
    //       if (!insurance.signatureImageId)
    //         return 1
    //       else if (insurance.operationType == 0 || insurance.operationType == 2)
    //         return 2
    //     }
    //   }
    // }
    return 2
  }

  const handleNext = () => {
    setActiveStep(prevActiveStep => {
      let newStep = prevActiveStep + 1
      if (newStep == 3) newStep = 6
      if (newStep == 8) newStep = 9
      // if (prevActiveStep == 5 && carInfo.vehicleStatus == 1)
      //   newStep += 1
      return newStep
    })
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => {
      let newStep = prevActiveStep - 1
      if (newStep == 8) newStep = 7
      if (newStep == 5) newStep = 2
      // if (prevActiveStep == 7 && carInfo.vehicleStatus == 1)
      //   newStep -= 1
      return newStep
    })
  }

  const GetStep = () => {
    switch (activeStep) {
      case 0:
        return <GetDeliberatelyPage handleNext={handleNext} />
      case 1:
        if (takePictureMode == 'MODE1')
          return <VehicleVisitingPointsMode1Page handleNext={handleNext} handleBack={handleBack} />
        else
          return <VehicleVisitingPointsMode2Page handleNext={handleNext} handleBack={handleBack} />
      case 2:
        return <ImagesCheck handleNext={handleNext} handleBack={handleBack} />
      case 3:
        return <GetCarInfoPage handleNext={handleNext} handleBack={handleBack} />
      case 4:
        return <GetCustomerInfoPage handleNext={handleNext} handleBack={handleBack} />
      case 5:
        return <GetOptionsPage handleNext={handleNext} handleBack={handleBack} />
      case 6:
        return <NotHealthyAutoPartsPage handleNext={handleNext} handleBack={handleBack} />
      case 7:
        return <VehicleAccessoriesPage handleNext={handleNext} handleBack={handleBack} />
      case 8:
        return <GetPricePage handleNext={handleNext} handleBack={handleBack} />
      // case 7:
      //   return <GetCoveragesPage handleNext={handleNext} handleBack={handleBack} />
      case 9:
        return <GetDescriptionPage handleBack={handleBack} isFake={true} />
      default:
        return <GetCarInfoPage handleNext={handleNext} handleBack={handleBack} />
    }
  }

  return (
    <React.Fragment>
      {hasAccess() == 2 ? (
        <React.Fragment>
          <NewVisitHeader activeStep={activeStep} />
          <GetStep />
        </React.Fragment>
      ) : (
        <AccessDenied messageType={hasAccess()} />
      )}
    </React.Fragment>
  )
}

export default NewVisitPage
